<template>
  <div>
    <PageHeader :schema="$schemas.checkControl" />
    <PageContent>
      <DynamicListPage
        :schema="$schemas.checkControl"
        :service="$api.checkControls"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicListPage from '@/components/dynamics/DynamicListPage';

export default {
  name: 'ListCheckControls',
  components: {
    PageHeader,
    PageContent,
    DynamicListPage,
  },
};
</script>
